// src/pages/Unauthorized.tsx
import React from "react";
import { Box, Container, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";
import ErrorIcon from "@mui/icons-material/Error";

export const Unauthorized = ({ error }: { error?: string | null }) => {
	const navigate = useNavigate();

	const handleLogout = async () => {
		try {
			await auth.signOut();
			navigate("/login");
		} catch (err) {
			console.error("Logout error:", err);
		}
	};

	return (
		<Container maxWidth="sm">
			<Box
				sx={{
					padding: { xs: "1rem", sm: "2rem" },
					margin: "auto",
					mt: { xs: 4, md: 8 },
					textAlign: "center"
				}}
			>
				<ErrorIcon
					sx={{
						fontSize: 80,
						color: "error.main",
						mb: 2
					}}
				/>
				<Typography
					variant="h4"
					component="h1"
					sx={{
						fontWeight: 700,
						mb: 2,
						fontSize: { xs: "1.5rem", sm: "2.125rem" }
					}}
				>
					Access Denied
				</Typography>
				<Typography
					variant="body1"
					color="textSecondary"
					sx={{ mb: 3 }}
				>
					{error ||
						"Your email is not authorized to access this application. Please contact the administrator for access."}
				</Typography>
				<Button
					variant="contained"
					color="primary"
					onClick={handleLogout}
					sx={{ mt: 2 }}
				>
					Sign Out
				</Button>
			</Box>
		</Container>
	);
};
